module.exports = __webpack_public_path__ + "img/jp-selles.94479313.png";